import {
    FETCH_COMPARISON,
    FETCH_COMPARISON_FAIL,
    FETCH_COMPARISON_RUNS_GAVE_UP,
    FETCH_COMPARISON_RUNS_RETRY,
    FETCH_COMPARISON_RUNS_SUCCESS,
    FETCH_COMPARISON_SUCCESS,
    FETCH_WORKSPACE_CONFIG,
    FETCH_WORKSPACE_CONFIG_FAIL,
    FETCH_WORKSPACE_CONFIG_SUCCESS,
    FOLLOW_COMPARISON,
    START_COMPARISON,
    START_COMPARISON_FAIL,
    START_COMPARISON_SUCCESS,
    STOP_FOLLOWING_COMPARISON
} from './actionTypes';

export const fetchWorkspaceConfig = ({ workspace }) => ({
    type: FETCH_WORKSPACE_CONFIG,
    payload: { workspace }
});

export const fetchWorkspaceConfigSuccess = ({ workspace, rules, risk }) => ({
    type: FETCH_WORKSPACE_CONFIG_SUCCESS,
    payload: { workspace, rules, risk }
});

export const fetchWorkspaceConfigFail = error => ({
    type: FETCH_WORKSPACE_CONFIG_FAIL,
    payload: error
});

/* args: { workspace, seed?, label?, scenarios, changes, riskRatios? } */
export const startComparison = args => ({
    type: START_COMPARISON,
    payload: args
});

export const startComparisonSuccess = response => ({
    type: START_COMPARISON_SUCCESS,
    payload: response
});

export const startComparisonFail = error => ({
    type: START_COMPARISON_FAIL,
    payload: error
});

export const followComparison = ({ baselineRunId, variantRunId }) => ({
    type: FOLLOW_COMPARISON,
    payload: { baselineRunId, variantRunId }
});

export const stopFollowingComparison = () => ({
    type: STOP_FOLLOWING_COMPARISON
});

export const fetchComparisonRunsSuccess = ({ baseline, variant }) => ({
    type: FETCH_COMPARISON_RUNS_SUCCESS,
    payload: { baseline, variant }
});

export const fetchComparisonRunsRetry = () => ({
    type: FETCH_COMPARISON_RUNS_RETRY
});

export const fetchComparisonRunsGaveUp = () => ({
    type: FETCH_COMPARISON_RUNS_GAVE_UP
});

/* playerLimit: how many of the players whose outcome changed are listed (their count is always given) */
export const fetchComparison = ({
    baselineRunId,
    variantRunId,
    playerLimit
}) => ({
    type: FETCH_COMPARISON,
    payload: { baselineRunId, variantRunId, playerLimit }
});

export const fetchComparisonSuccess = comparison => ({
    type: FETCH_COMPARISON_SUCCESS,
    payload: comparison
});

export const fetchComparisonFail = error => ({
    type: FETCH_COMPARISON_FAIL,
    payload: error
});
